<template>
	<div>
		<van-form style="padding-bottom: 50px;">
			<van-field
				v-model="process_id_text"
				label="流程"
				placeholder="选择流程"
				readonly
				@click="popup.process = true"
				:rules="[{ required: true, trigger: ' onBlur', message: '请选择出差流程' }]"
			/>
			<van-field
				v-model="form.xmmc"
				label="项目名称"
				placeholder="输入项目名称"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入项目名称' }]"
			/>
			<van-field
				v-model="form.hxsj"
				label="花销时间"
				placeholder="输入花销时间"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入花销时间' }]"
			/>
			<van-field
				v-model="bxlx_text"
				name="报销类型"
				label="报销类型"
				placeholder="选择报销类型"
				readonly
				@click="popup.bxlx = true"
				:rules="[{ required: true, trigger: ' onBlur', message: '请选择报销类型' }]"
			/>
			<van-field
				v-model="form.bxsm"
				label="报销说明"
				placeholder="输入报销说明"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入报销说明' }]"
			/>
			<van-field
				v-model="form.je"
				label="金额"
				placeholder="输入金额"
				type="numbner"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入金额' }]"
			/>
			<div style="margin: 16px;">
				<van-button round block type="info" @click="onSubmit" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-popup v-model="popup.process" position="bottom">
			<van-picker
				show-toolbar
				:columns="processList"
				@cancel="popup.process = false"
				@confirm="confirmProcess"
				value-key="process_name"
			/>
		</van-popup>
		<van-popup v-model="popup.bxlx" position="bottom">
			<van-picker
				show-toolbar
				:columns="bxlxList"
				@cancel="popup.bxlx = false"
				@confirm="confirmbxlx"
			/>
		</van-popup>
	</div>
</template>

<script>
import { getList } from "@/api/review";
import { Toast } from "vant";

export default {
	name: "purchase",
	data() {
		return {
			type_id: this.$route.query.type,
			process_id: "",
			process_id_text: "",
			bxlx_text: "",
			form: {
				xmmc: "",
				hxsj: "",
				bxsm: "",
				bxlx: "",
				je: ""
			},
			processList: [],
			popup: {
				process: false,
				bxlx: false
			},
			bxlxList: [
				{ text: "交通", id: 0 },
				{ text: "住宿", id: 1 },
				{ text: "餐饮", id: 2 },
				{ text: "其他", id: 3 }
			]
		};
	},
	mounted() {
		this.getPurchaseList();
	},
	methods: {
		onSubmit() {
			this.$emit("sub", {
				requestType: "process_apply",
				process_id: this.process_id,
				apply_data: JSON.stringify(this.form),
				apply_rmb:  this.form.je
			});
		},
		getPurchaseList() {
			getList({
				requestType: "process_type",
				type_id: this.type_id
			})
				.then(res => {
					this.processList = res.obj;
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		clearForm() {
			for (var key in this.form) {
				if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.process_id_text = "";
			this.process_id = "";
			this.bxlx_text = "";
		},
		confirmProcess(value) {
			this.process_id_text = value.process_name;
			this.process_id = value.process_id;
			this.popup.process = false;
		},
		confirmbxlx(value) {
			this.bxlx_text = value.text;
			this.form.bxlx = value.id;
			this.popup.bxlx = false;
		}
	}
};
</script>